/* GoGrowth, Sep 2026: cart-drawer recommendations.
   Fills [data-cc-recs] inside #halo-cart-sidebar with products related to what is in the cart,
   using Shopify's /recommendations/products.json (intent=related) for the most recently added
   item, topped up from the next item. Products already in the cart, or unavailable, are skipped.
   "Add" posts to /cart/add.js and then re-fetches the drawer body the same way the theme does
   (/cart?view=ajax_side_cart), so totals, the free-delivery bar and the header count all update. */
(function () {
  'use strict';
  var ROOT = '#halo-cart-sidebar';
  var cache = {};
  var building = false;

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.money_format || '{{amount}}');
      }
    } catch (e) {}
    return (cents / 100).toFixed(2);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function fetchRecs(productId) {
    if (!cache[productId]) {
      cache[productId] = fetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return cache[productId];
  }

  function firstVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return vs[0] || null;
  }

  function cardHtml(p) {
    var v = firstVariant(p);
    if (!v) return '';
    var price = p.price;
    var was = p.compare_at_price && p.compare_at_price > price ? p.compare_at_price : 0;
    var off = was ? Math.round((1 - price / was) * 100) : 0;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return '<div class="cc-rec" data-cc-rec="' + p.id + '">' +
      '<a class="cc-rec__img" href="' + esc(p.url) + '">' +
        (img ? '<img src="' + esc(imgUrl(img, 240)) + '" alt="' + esc(p.title) + '" loading="lazy" width="120" height="120">' : '') +
        (off >= 10 ? '<span class="cc-rec__off">-' + off + '%</span>' : '') +
      '</a>' +
      '<a class="cc-rec__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<div class="cc-rec__price"><span class="cc-rec__now' + (was ? ' is-sale' : '') + '">' + money(price) + '</span>' +
        (was ? '<s class="cc-rec__was">' + money(was) + '</s>' : '') + '</div>' +
      '<button type="button" class="cc-rec__add" data-cc-add="' + v.id + '" aria-label="Add ' + esc(p.title) + ' to cart">' + (document.documentElement.lang === 'ar' ? 'أضف' : 'Add') + '</button>' +
    '</div>';
  }

  function build() {
    var box = document.querySelector(ROOT + ' [data-cc-recs]');
    if (!box || box.dataset.ccBuilt) return;
    box.dataset.ccBuilt = '1';
    var ids = (box.dataset.ccProducts || '').split(',').filter(Boolean);
    if (!ids.length) { box.hidden = true; return; }
    var inCart = {};
    ids.forEach(function (id) { inCart[id] = true; });
    var limit = parseInt(box.dataset.ccLimit, 10) || 6;
    var ok = function (p) { return p && p.available && !inCart[String(p.id)]; };

    fetchRecs(ids[0]).then(function (list) {
      var out = list.filter(ok);
      if (out.length < limit && ids[1]) {
        return fetchRecs(ids[1]).then(function (more) {
          more.filter(ok).forEach(function (p) {
            if (!out.some(function (o) { return o.id === p.id; })) out.push(p);
          });
          return out;
        });
      }
      return out;
    }).then(function (out) {
      out = out.slice(0, limit);
      var row = box.querySelector('[data-cc-recs-row]');
      if (!out.length || !row) { box.hidden = true; return; }
      row.innerHTML = out.map(cardHtml).join('');
      box.hidden = false;
    });
  }

  function setHtmlWithScripts(el, html) {
    el.innerHTML = html;
    el.querySelectorAll('script').forEach(function (old) {
      var s = document.createElement('script');
      [].forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
      s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  // Re-render the drawer body the way the theme does (/cart?view=ajax_side_cart), fetching the cart
  // JSON in parallel for the header count / free-delivery bar. Returns a promise of the cart.
  function refreshDrawer() {
    var wrap = document.querySelector(ROOT + ' .previewCart-wrapper');
    if (!wrap) return Promise.resolve(null);
    var recs = wrap.querySelector('[data-cc-recs]');
    if (recs) recs.classList.add('cc-loading');
    var root = (window.routes && window.routes.root) || '';
    var opts = { cache: 'no-store', credentials: 'same-origin' };
    return Promise.all([
      fetch(root + '/cart.js', opts).then(function (r) { return r.json(); }),
      fetch(root + '/cart?view=ajax_side_cart', opts).then(function (r) { return r.text(); })
    ]).then(function (res) {
      var cart = res[0], html = res[1];
      if (window.jQuery) { window.jQuery(wrap).html(html); } else { setHtmlWithScripts(wrap, html); }
      var ar = document.documentElement.lang === 'ar';
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.querySelectorAll('[data-cart-text]').forEach(function (el) {
        el.textContent = cart.item_count === 1 ? (ar ? 'منتج' : 'item') : (ar ? 'منتجات' : 'items');
      });
      document.querySelectorAll('[data-free-shipping-wrapper]').forEach(function (w) {
        w.dispatchEvent(new Event('change', { bubbles: true }));
      });
      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
      build();
      return cart;
    });
  }

  // Used by the PDP buy box (pdp-section) so its Add to Cart opens this drawer instead of reloading /cart.
  window.ccCart = {
    refresh: refreshDrawer,
    open: function () {
      document.body.classList.add('cart-sidebar-show');
      return refreshDrawer();
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-add]');
    if (!btn || !btn.closest(ROOT)) return;
    e.preventDefault();
    if (btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.ccAdd, 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      btn.classList.add('is-added');
      btn.textContent = document.documentElement.lang === 'ar' ? 'تمت الإضافة' : 'Added';
      return new Promise(function (done) { setTimeout(done, 350); });
    }).then(refreshDrawer).catch(function () {
      btn.disabled = false;
      btn.classList.add('is-error');
      btn.textContent = document.documentElement.lang === 'ar' ? 'حاول مجدداً' : 'Try again';
      setTimeout(function () { btn.classList.remove('is-error'); btn.textContent = label; }, 2000);
    });
  });

  // The theme replaces the drawer body on every cart change; rebuild whenever that happens.
  function watch() {
    var root = document.querySelector(ROOT);
    if (!root) return;
    new MutationObserver(function () {
      if (building) return;
      building = true;
      requestAnimationFrame(function () { building = false; build(); });
    }).observe(root, { childList: true, subtree: true });
    build();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
